<template>
  <section class="app-education">
    <integration-steps :current-step="1" />

    <article class="app-education__form">
      <div class="app-education__form-col">
        <h5 class="app-education__form-subtitle">
          Foto de exibição
        </h5>

        <div class="minhaconta__avatar">
          <img
            :src="localDoctor['profile_picture']"
            class="minhaconta__avatar-image"
          />

          <span
            class="minhaconta__avatar-editar"
            @click="ui.modalUserImage = true"
          >
            Editar
          </span>

          <user-image
            :active="ui.modalUserImage"
            :image.sync="localDoctor['profile_picture']"
            @status="ui.modalUserImage = $event"
            @newImage="updateUser()"
          />
        </div>
      </div>

      <div class="app-education__form-col">
        <h5 class="app-education__form-subtitle">
          Apresentação
        </h5>

        <div class="app-education__form-field">
          <dr-field
            :key="`app-education-field-${formData.presentation.name}`"
            :id="formData.presentation.name"
            :ref="formData.presentation.name"
            :form.sync="formData"
            :field.sync="formData.presentation"
            :value.sync="formData.presentation.value"
            :disabled="ui.loading"
            prefix="app-integration-education"
            class="app-education__form-textarea"
          />
        </div>
      </div>

      <div class="app-education__form-col app-education__form-col--full">
        <h5 class="app-education__form-subtitle">
          Formação profissional
        </h5>

        <div class="app-education__form-wrapper">
          <div
            v-for="field of formData"
            :key="`field-${field.name}`"
            :class="[
              (!field.display) && 'app-education__form-field--none',
              ...field.classes
            ]"
            class="app-education__form-field"
          >
            <dr-field
              v-if="field.display"
              :id="field.name"
              :ref="field.name"
              :key="`app-education-field-${field.name}`"
              :form.sync="formData"
              :field="field"
              :value.sync="field.value"
              :disabled="ui.loading"
              prefix="app-integration-education"
              class="app-education__form-textarea"
            />
          </div>
        </div>

        <div class="app-integration__footer">
          <dr-submit
            :sending="ui.loading"
            :disabled="ui.loading"
            text="Próximo"
            class="app-integration__submit"
            @click="save()"
          />
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { formData, validations } from '@/data/formData/appIntegration/doctorEducation'
import integrationSteps from '@/components/layout/appIntegration/integrationSteps'
import userImage from '@/components/modals/userImage'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import EventBus from '@/globals/eventBus'

export default {
  name: 'AppIntegrationEducation',

  components: {
    integrationSteps,
    userImage,
    drSubmit,
    drField
  },

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      formData,
      localDoctor: null,
      ui: {
        modalUserImage: false,
        loading: false
      }
    }
  },

  watch: {
    doctor: {
      deep: true,
      immediate: true,
      handler () {
        this.init()
      }
    }
  },

  created () {
    this.localDoctor['profile_picture'] = this.localDoctor.user.gender === 'F'
      ? require('@/assets/img/f_default.png')
      : require('@/assets/img/m_default.png')

    // Get presentation info
    this.ui.loading = true
    this.fn_SHOW_PROGRESS()

    this.getPresentation()
      .then((res) => {
        this.formData.presentation.value = res.data
        this.formData.isAmbEspecialization.value = this.localDoctor['is_amb_especialization'] ? 1 : 0
        this.formData.university.value = this.localDoctor['university']
        this.formData.universityEndDate.value = this.localDoctor['university_end_date']
        this.formData.universityStartDate.value = this.localDoctor['university_start_date']

        this.$set(
          this.formData.specializationCourses,
          'value',
          this.localDoctor['specialization_courses']
            .map(c => ({ name: c.name }))
        )
      })
      .catch(err => console.log(err))
      .finally(() => {
        this.ui.loading = false
        this.fn_HIDE_PROGRESS()
      })
  },

  destroyed () {
    this.destroyApiObject(this.formData)
  },

  methods: {
    init () {
      this.ui.loading = true
      this.fn_SHOW_PROGRESS()

      this.localDoctor = { ...this.doctor }

      this.getProfilePicture()
        .finally(() => {
          this.ui.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    getProfilePicture () {
      const url = `/s3/file/doctor/${this.localDoctor.id}/profile_picture?${new Date().getTime()}`
      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then(() => {
          this.localDoctor['profile_picture'] = `${process.env.ROOT_API}${url}`
          this.localDoctor.hasProfilePicture = true
        })
        .catch(() => {
          this.localDoctor['profile_picture'] = this.localDoctor.user.gender === 'F'
            ? require('@/assets/img/f_default.png')
            : require('@/assets/img/m_default.png')

          this.localDoctor.hasProfilePicture = false
        })
    },

    getAppIntegration () {
      this.$http
        .get('/doctor/app_integration', this.$store.getters.getAuthHeader)
        .then(res => this.$store.dispatch('setAppIntegration', res.data['app_integration']))
    },

    getPresentation () {
      return this.$http
        .get('/doctor/presentation', this.$store.getters.getAuthHeader)
    },

    save () {
      if (!this.localDoctor.hasProfilePicture) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'É necessário cadastrar uma foto de perfil.',
          size: 'md',
          active: true
        })

        return
      }

      if (this.$v.$invalid) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'É necessário preencher o formulário corretamente.',
          size: 'md',
          active: true
        })

        return
      }

      const url = '/doctor/app_integration/doctor/register'
      const data = this.buildApiObject(this.formData)

      this.ui.loading = true
      this.fn_SHOW_PROGRESS()

      this.$http
        .put(url, data, this.$store.getters.getAuthHeader)
        .then((res) => {
          if (res.status === 200 || /ok/gi.test(res.statusText)) {
            return true
          }
        })
        .then(() => this.getAppIntegration())
        .then(() => this.fn_GET_DOCTOR())
        .then((doctor) => {
          EventBus.$emit('updated-user-data', doctor)

          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Informações salvas com sucesso.',
            size: 'md',
            active: true
          })

          setTimeout(() => {
            this.$store.dispatch('setModalAlert')
            this.$router.push({ name: 'DoctorAppIntegrationOffices' })
          }, 2000)
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.ui.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    updateUser () {
      this.ui.loading = true
      this.fn_SHOW_PROGRESS()

      this.fn_GET_DOCTOR()
        .then(doctor => EventBus.$emit('updated-user-data', doctor))
        .catch(err => console.log(err))
        .finally(() => {
          this.ui.loading = false
          this.fn_HIDE_PROGRESS()
          this.init()
        })
    },

    buildApiObject (data) {
      const doctor = { doctor: {} }

      Object.keys(data)
        .map((key) => {
          if (data[key].value !== undefined && data[key] !== null) {
            doctor.doctor[key] = data[key].value
          }
        })

      return doctor
    },

    destroyApiObject (object) {
      const recursiveNullify = (obj) => {
        for (const key in obj) {
          if ('value' in obj[key]) {
            obj[key].value = null
          } else {
            recursiveNullify(obj[key])
          }
        }
      }

      recursiveNullify(object)
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
